import { render, staticRenderFns } from "./CurrencyExchangeList.vue?vue&type=template&id=0bc42042"
import script from "./CurrencyExchangeList.vue?vue&type=script&lang=js"
export * from "./CurrencyExchangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports